import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 是否禁止到期合同创建业务
export function isContractExpiredForbidCreateJob(cmpIdx) {
  return request({
    url: URL.booking.isContractExpiredForbidCreateJob,
    method: 'get',
    params: { cmpIdx }
  })
}

// 加载Job的关联实体信息
export function loadIntegratedJobRelatedFunc(data) {
  return request({
    url: URL.booking.integratedJob.loadIntegratedJobRelatedUrl,
    method: 'post',
    data: data
  })
}

// 高级查询
export function advancedQuery(data) {
  return request({
    url: URL.booking.integratedJob.advancedQueryUrl,
    method: 'post',
    data
  })
}

// 复制业务
export function doCopyJob(data) {
  return request({
    url: URL.booking.integratedJob.doCopyJobUrl,
    method: 'post',
    data
  })
}

// 最近修改的单子
export function queryLastModifyBookingByDay(data) {
  return request({
    url: URL.booking.integratedJob.queryLastModifyBookingByDayUrl,
    method: 'post',
    data
  })
}

// 保存综合物流订舱信息
export function saveIntegratedJob(data, fullError, forbidAlert) {
  return request({
    url: URL.booking.integratedJob.saveIntegratedJobUrl,
    method: 'post',
    fullError,
    forbidAlert,
    data
  })
}

export function saveCopyJob(data) {
  return request({
    url: URL.booking.integratedJob.saveCopyJobUrl,
    method: 'post',
    data
  })
}

// 主票加入小票-查询
export function getIntegratedJobsByLclMasterJobFunc(data) {
  return request({
    url: URL.booking.integratedJob.getIntegratedJobsByLclMasterJobUrl,
    method: 'post',
    data
  })
}

// 主票加入小票
export function batchAddJobFunc(data, lclMasterUuid, location) {
  return request({
    url: URL.booking.integratedJob.batchAddJobUrl,
    method: 'post',
    data,
    params: { lclMasterUuid, location }
  })
}

// 解绑主票和小票关联
export function unbindingNewFunc(data, lclMasterUuid, location) {
  return request({
    url: URL.booking.integratedJob.unbindingNewUrl,
    method: 'post',
    data,
    params: { lclMasterUuid, location }
  })
}

// 根据业务ID获取综合物流业务
export function getIeJobByUuidFunc(uuid) {
  return request({
    url: URL.booking.integratedJob.getIeJobByUuidUrl,
    method: 'get',
    params: { uuid }
  })
}

// 审核通过
export function acceptJobFunc(data) {
  return request({
    url: URL.booking.integratedJob.acceptJobUrl,
    method: 'post',
    data
  })
}

// 拒绝
export function preVerifyRejectFunc(data) {
  return request({
    url: URL.booking.integratedJob.preVerifyRejectUrl,
    method: 'get',
    params: data
  })
}

// 批量拒绝
export function batchPreVerifyRejectFunc(params) {
  return request({
    url: URL.booking.integratedJob.batchPreVerifyRejectFunc,
    method: 'post',
    data: params
  })
}

// 复核通过
export function reviewThroughFunc(data) {
  return request({
    url: URL.booking.integratedJob.reviewThroughUrl,
    method: 'post',
    data
  })
}

// 复核拒绝
export function reviewRefusalFunc(data) {
  return request({
    url: URL.booking.integratedJob.reviewRefusalUrl,
    method: 'post',
    data
  })
}

export function saveCloneJobFunc(data) {
  return request({
    url: URL.booking.integratedJob.saveCloneJobUrl,
    method: 'post',
    data
  })
}

export function getRelatedJobFunc(jobNo) {
  return request({
    url: URL.booking.integratedJob.getRelatedJobUrl,
    method: 'get',
    params: { jobNo }
  })
}
